import React from 'react'
import BestSellers from './bestSellers/BestSellers'
import LineChartComponent from './lineChartComponent/LineChartComponent'
import SoldBoxes from './soldBoxes/SoldBoxes'
import PolarAreaChart from './polarAreaChart/PolarAreaChart'
import { Row, Col } from 'react-bootstrap'
import AreaChart from './areaChart/AreaChart'
import DoughnutChart from './doughnutChart/DoughnutChart'
import GenericTitleP from '../titles/GenericTitleP'
import TabTitleH2 from '../titles/TabTitleH2'


const Sales = () => {
  return (<div style={{paddingBottom: "40px"}}>
    <TabTitleH2>Overall Sales Data</TabTitleH2>
    <SoldBoxes />
    <Row className='mt-4'>
      <Col sm={12}>
        <GenericTitleP>Alltimes Bestsellers</GenericTitleP>
      </Col>
      <Col lg={8} sm={12}>
        <BestSellers />
      </Col>
      <Col lg={4} sm={12}>
        <DoughnutChart />
      </Col>
      <Row>
        <Col sm={12}>
          <AreaChart />
        </Col>
        <Col lg={8}>
          <LineChartComponent />
        </Col>
        <Col className="" sm={12} lg={4}>
          <PolarAreaChart />
        </Col>
      </Row>
    </Row>

  </div>)
}

export default Sales